<template>
  <d-modal
    v-if="showModal"
    class="crm-new-popup weighing-module-form">
    <d-modal-header>
      <d-modal-title>
        <div>
          <h3 class="page-title weighing-module-title mt-0">
            <span class="text-success">{{order.customer_name}}</span>
          </h3>
        </div>
        <div
          v-if="order.customer.shops && order.customer.shops.length > 1 && order.shop_name"
          class="bottom-text bottom-text-value">
          <span class="text-secondary">Placówka: </span>
          <span class="text-success">{{ order.shop_name }}</span>
        </div>
        <d-row
          no-gutters
          class="mt-3 weighing-module-title-bottom">
          <d-col
            col
            sm="6"
            class="text-center text-sm-left mt-0 bottom-text bottom-text-value">
            <d-checkbox
              class="mt-1 mb-1"
              v-model="show_all_products">
              Pokaż zważone produkty
            </d-checkbox>
          </d-col>
          <d-col
            col
            sm="6"
            class="text-right text-sm-right d-flex">
            <div class="form-group my-0">
              <d-button
                @click="downloadLabel"
                class="mt-0 mb-1 text-nowrap"
                theme="primary"
                outline
                type="button"
                :disabled="isDownloading">
                <i
                  class="material-icons"
                  aria-hidden="true">download</i>
                Pobierz etykietę
              </d-button>
            </div>
          </d-col>
        </d-row>

        <div class="view-mode-switcher mt-3 d-flex justify-content-center border-top pt-3">
          <d-button-group>
            <d-button
              @click="viewMode = 'list'"
              :theme="viewMode === 'list' ? 'primary' : 'light'"
              :outline="viewMode !== 'list'"
              type="button">
              <i class="material-icons">view_list</i> 1 Kolumna
            </d-button>
            <d-button
              @click="viewMode = 'grid'"
              :theme="viewMode === 'grid' ? 'primary' : 'light'"
              :outline="viewMode !== 'grid'"
              type="button">
              <i class="material-icons">grid_view</i> 2 Kolumny
            </d-button>
          </d-button-group>
        </div>

      </d-modal-title>
    </d-modal-header>
    <d-modal-body class="weighing-modal-body">
      <d-alert
        v-if="show_backup_alert"
        show
        theme="warning"
        class="d-flex align-items-center">
        Znaleziono zapisaną kopię danych zamówienia inną niż obecny status. Czy chcesz przywrócić te dane?
        <d-button
          theme="light"
          class="ml-auto"
          @click.prevent="restoreBackup()"
          type="button">
          Tak, przywróć
        </d-button>
      </d-alert>
      <d-alert
        v-if="isDebtWarningVisible"
        show
        theme="danger">
        Zadłużenie klienta przekracza wartość zamówień z ostatnich 14 dni
      </d-alert>
      <div
        v-if="!template_list_load"
        class="spinner-load" >
        <div
          class="spinner-border spinner-border-sm crm-new-popup-spinner"
          role="status"></div>
      </div>
      <validation-observer
        ref="weighing-module-form"
        tag="form">
        <div
          v-if="template_list_load"
          class="grid-view-wrapper border-bottom pb-3"
          :class="{'is-list-mode': viewMode === 'list'}">

          <div
            v-if="products_to_send.length > 0"
            class="grid-headers m-n1 mb-2 d-flex"
            :class="viewMode === 'grid' ? 'is-grid' : 'is-list'">
            <div class="header-col px-1">
              <div
                class="d-flex p-2 w-100 text-muted"
                style="font-size: 11px; text-transform: uppercase;">
                <div class="flex-grow-1 pr-2">Produkt</div>
                <div
                  class="px-2 text-right"
                  style="width: 100px; min-width: 100px;">Ilość</div>
                <div
                  class="px-2 text-right"
                  style="width: 95px; min-width: 95px;">Waga / Potw.</div>
                <div
                  class="px-2 text-right"
                  style="width: 100px; min-width: 100px;">Kwota</div>
                <div
                  class="pl-1"
                  style="width: 40px; min-width: 40px;"></div>
              </div>
            </div>
            <div
              v-if="viewMode === 'grid'"
              class="header-col px-1 d-none d-md-block">
              <div
                class="d-flex p-2 w-100 text-muted"
                style="font-size: 11px; text-transform: uppercase;">
                <div class="flex-grow-1 pr-2">Produkt</div>
                <div
                  class="px-2 text-right"
                  style="width: 100px; min-width: 100px;">Ilość</div>
                <div
                  class="px-2 text-right"
                  style="width: 95px; min-width: 95px;">Waga / Potw.</div>
                <div
                  class="px-2 text-right"
                  style="width: 100px; min-width: 100px;">Kwota</div>
                <div
                  class="pl-1"
                  style="width: 40px; min-width: 40px;"></div>
              </div>
            </div>
          </div>

          <div
            class="m-n1"
            :class="viewMode === 'grid' ? 'custom-grid-columns' : 'row row-cols-1'"
            :style="viewMode === 'grid' ? { gridTemplateRows: `repeat(${gridRowsCount}, auto)` } : {}">
            <template v-for="(product, index) in products_to_send">
              <div
                v-if="getIsElementVisible(index)"
                :key="index"
                class="col p-1 transition-all">
                <div
                  class="card grid-item shadow-sm h-100"
                  :class="{
                    'weighed': !getIsElementToBeWeighted(index),
                    'editable-mode': product.isEditable
                  }"
                  @keypress.enter.prevent="addProduct()">
                  <div class="card-body p-2 d-flex align-items-center">

                    <div
                      class="pr-2 border-right d-flex flex-column justify-content-center flex-grow-1"
                      style="min-width: 0;">
                      <div
                        v-if="product.isEditable"
                        class="form-control is-select"
                        :key="'select-' + data.count">
                        <v-select
                          :filterBy="filterByName"
                          :key="data.count"
                          :ref="'product-select-' + index"
                          class="productsForPrice"
                          :name="'product-' + index"
                          @input="updateProduct($event, index)"
                          :options="shop_items_new"
                          v-model="product.product_id"
                          :reduce="item => item.id"
                          label="id">
                          <template
                            slot="option"
                            slot-scope="option">
                            {{ option.name ? option.name : option.product_name }}
                          </template>
                          <template
                            slot="selected-option"
                            slot-scope="option">
                            <div class="selected text-truncate">
                              {{ option.name ? option.name : option.product_name }}
                            </div>
                          </template>
                        </v-select>
                      </div>
                      <div
                        v-else
                        class="product-name text-primary"
                        :title="product.name">
                        {{ product.name }}
                      </div>

                      <div
                        v-if="product.description"
                        class="text-truncate mt-1"
                        style="font-size: 11px; line-height: 1.2;"
                        :title="product.description">
                        {{ product.description }}
                      </div>
                    </div>

                    <div
                      class="text-right border-right px-2 d-flex align-items-center justify-content-end"
                      style="width: 100px; min-width: 100px;">
                      <template v-if="product.isEditable || !product.weighing_required">
                        <div class="d-flex align-items-center w-100">
                          <input
                            :ref="'product-quantity-' + index"
                            @focus="$event.target.select()"
                            :disabled="product.weighing_required === 1 || !product.product_id"
                            style="padding: 0.3rem;"
                            :class="{
                              'custom-input-new flex-grow-1': true,
                              'custom-input-new-disabled': product.weighing_required === 1 || !product.product_id
                            }"
                            :step="1.0"
                            :min="0.0"
                            placeholder="0"
                            @input="updateQuantity(product.quantity, index, product.average_weight, product.product_unit)"
                            type="number"
                            v-model="product.quantity" />
                          <small class="ml-1 text-nowrap">{{ units[product.unit] || product.unit || 'szt.' }}</small>
                        </div>
                      </template>
                      <p
                        v-else
                        class="my-auto">
                        <span class="font-weight-bold">{{ product.quantity }}</span>
                        <small class="ml-1 text-nowrap">{{ units[product.unit] || product.unit || 'szt.' }}</small>
                      </p>
                    </div>

                    <div
                      class="text-right border-right px-2 d-flex align-items-center justify-content-end"
                      style="width: 95px; min-width: 95px;">
                      <template v-if="!product.weighing_required">
                        <d-button
                          v-if="!product.is_packed"
                          theme="success"
                          outline
                          size="sm"
                          title="Potwierdź"
                          class="btn-icon my-auto mx-auto"
                          :disabled="!product.product_id"
                          @click.prevent="setIsPacked(index)"
                          type="button">
                          <span class="material-icons">check</span>
                        </d-button>
                        <small
                          v-else
                          class="text-success font-weight-bold my-auto mx-auto">
                          <d-badge
                            class="weighting-badge"
                            outline
                            pill
                            theme="success"
                            size="sm">
                            <i class="material-icons">check</i>
                          </d-badge>
                        </small>
                      </template>
                      <template v-else>
                        <div
                          v-if="product.weighing_required === 1"
                          class="d-flex align-items-center w-100">
                          <input
                            :ref="'product-weight-' + index"
                            :id="'weight-input-'+ index"
                            @focus="$event.target.select()"
                            class="custom-input-new no-native-arrows flex-grow-1"
                            style="padding: 0.3rem;"
                            :step="1.0"
                            :min="0.0"
                            :disabled="!product.product_id"
                            :class="{ 'border-orange': product.weight === 0 || product.weight === '0' || !product.weight }"
                            placeholder="0.0"
                            @blur.prevent="productsWeightChanged($event, product.weight, index)"
                            @keydown="focusDifferentProductWeight($event, index)"
                            type="number"
                            v-model="product.weight" />
                          <small class="ml-1">kg</small>
                        </div>
                        <div
                          v-else
                          class="mx-auto">-</div>
                      </template>
                    </div>

                    <div
                      class="text-right border-right px-2 d-flex align-items-center justify-content-end"
                      style="width: 100px; min-width: 100px;">
                      <div
                        class="font-weight-bold my-auto"
                        :key="'product-price-' + product.id + '-' + data.count">
                        {{ product.price ? parseFloat(product.price).toFixed(2) : '0.00' }} <small>zł</small>
                      </div>
                    </div>

                    <div
                      class="d-flex align-items-center justify-content-center pl-2"
                      style="width: 40px; min-width: 40px;">
                      <d-button
                        theme="danger"
                        outline
                        size="sm"
                        title="Usuń produkt"
                        class="btn-icon ml-auto"
                        type="button"
                        @click.prevent="removeProduct(index)">
                        <span class="material-icons">delete</span>
                      </d-button>
                    </div>

                  </div>
                </div>
              </div>
            </template>
          </div>
        </div>

        <div
          v-if="data.customer_note"
          class="form-group border-bottom py-3" >
          <label class="mb-1">
            Notatka do zamówienia:
          </label>
          <p class="mb-0 text-primary">
            {{ data.customer_note }}
          </p>
        </div>
        <d-alert
          v-if="show_change_alert"
          class="mt-3"
          theme="info"
          show>
          Potwierdź aby zapisać wprowadzone zmiany.
        </d-alert>
        <d-row
          v-if="template_list_load"
          class="mt-3">
          <d-col
            cols="6"
            md="6"
            lg="6">
            <div class="form-group">
              <label :for="data.containers_number">
                Liczba pojemników:
              </label>

              <validation-provider
                name="containers_number"
                rules="integer"
                v-slot="{ errors }">
                <d-input
                  :state="errors.length ? 'invalid' : null"
                  type="number"
                  v-model="data.containers_number" />
                <div class="invalid-feedback">
                  {{ errors[0] }}
                </div>
              </validation-provider>
            </div>
          </d-col>
          <d-col
            cols="6"
            md="6"
            lg="6">
            <div class="order-table-sum">
              <div class="label">Łącznie:</div>
              <span>{{ suma ? suma.toFixed(2) : '0.00' }} zł</span>
            </div>
          </d-col>
        </d-row>
        <div class="popup-box-buttons">
          <d-button
            outline
            @click.prevent="addProduct"
            style="width: 100%"
            theme="primary"
            type="button">
            <i class="material-icons">add</i>
            Dodaj produkt
          </d-button>
          <d-button
            theme="success"
            class="text-nowrap ml-3"
            @click.prevent="validateForm">
            Potwierdź
          </d-button>
          <d-button
            theme="secondary"
            class="text-nowrap ml-3"
            @click.prevent="closeModal"
            type="button">
            Anuluj
          </d-button>
        </div>
      </validation-observer>
    </d-modal-body>
  </d-modal>
</template>

<script>
import Vue from 'vue';
import axios from 'axios';
import api from '@/api';
import FormUtils from '@/utils/FormUtils';
import CalendarUtils from '@/utils/CalendarUtils';

export default {
  name: 'orders-weighing-module',
  data () {
    return {
      viewMode: 'list', // 'grid' || 'list'
      data: {
        containers_number: 0,
        count: 0,
        countParam: 0,
        customer: {},
        customer_id: '',
        customer_name: [],
        customer_note: '',
        delivery_date: '',
        description: [],
        id: 0,
        product_id: [],
        products: [],
        quantity: [],
        shop_id: '',
        sum: [],
        weight: []
      },
      products_init: [],
      products_order: [],
      products_to_send: [],
      shop_items_new: [],
      show_all_products: false,
      show_backup_alert: false,
      show_change_alert: false,
      template_list_load: false,
      unit_box: '',
      units: {
        KILOGRAM: 'kg',
        PIECE: 'szt.'
      },
      isDownloading: false
    };
  },
  props: {
    showModal: {
      type: Boolean,
      required: true
    },
    closeModal: {
      type: Function,
      required: true
    },
    order: {
      type: [Array, Object],
      required: true
    },
    refreshList: {
      type: Function,
      required: true
    },
    date: {
      type: [String, Number],
      required: false
    },
    supplier: {
      type: [String, Number],
      required: true
    },
    isEdit: {
      type: [String, Number],
      required: true
    }
  },
  computed: {
    isDebtWarningVisible () {
      if (!this.loaded) {
        return false;
      }

      if (!this.data.customer) {
        return false;
      }

      return Number(this.data.customer.dept) >= Number(this.data.customer.latest_14_days_orders_price);
    },
    gridRowsCount () {
      if (!this.products_to_send) {
        return 1;
      }

      let visibleCount = 0;
      for (let i = 0; i < this.products_to_send.length; i++) {
        if (this.getIsElementVisible(i)) {
          visibleCount++;
        }
      }

      return Math.max(1, Math.ceil(visibleCount / 2));
    }
  },
  mounted () {
    this.loaded = true;
  },
  watch: {
    'isEdit': function (value) {
      if (value) {
        setTimeout(() => {
          this.loadItemData();
        }, 200);
      }
    },
    'data.customer_id': function (value) {
      if (value !== '') {
        this.getOrderProducts();
      }
    },
    'products_order': function (value) {
      if (value) {
        this.shop_items_new = JSON.parse(JSON.stringify(value)).sort((a, b) => ((a.name > b.name) ? 1 : -1));
        this.template_list_load = true;
      }
    },
  },
  methods: {
    getIsElementToBeWeighted (index) {
      let currentProduct = this.products_to_send[index];
      let isElementVisible = false;

      if (currentProduct.weighing_required) {
        isElementVisible = (!currentProduct.weight || Number(currentProduct.weight) <= 0);
      } else {
        isElementVisible = !currentProduct.is_packed;
      }

      if ('productValueSaved' in currentProduct) {
        isElementVisible = !currentProduct.productValueSaved;
      }
      return isElementVisible;
    },
    getIsElementVisible (index) {
      let isElementVisible = this.getIsElementToBeWeighted(index);
      return (this.show_all_products || isElementVisible);
    },
    productsWeightChanged (e, weight, index) {
      if ('productValueSaved' in this.products_to_send[index]) {
        this.products_to_send[index].productValueSaved = true;
      }
      this.show_change_alert = true;
      this.products_init = [...this.data.products];
      this.updateWeight(weight, index);
    },
    filterByName (option, label, search) {
      return (option.name).toLowerCase().indexOf(search.toLowerCase()) > -1;
    },
    getOrderProducts () {
      let where = {
        in_order: 1
      };
      if (this.data.customer_id !== null && this.data.customer_id && this.data.customer_id.value) {
        where.customer_id = this.data.customer_id;
      }
      if (this.data.shop_id !== null && this.data.shop_id && this.data.shop_id.value) {
        where.shop_id = this.data.shop_id;
      }
      FormUtils.loadAdditionalData(this, {
        endpoint: '/products/items?in_order=1',
        outputKey: 'products_order',
        params: {
          pagination: false,
          in_order: 1,
          customer_id: this.data.customer_id,
          shop_id: this.data.shop_id
        },
        successAction: () => {
          this.getProductsTodo();
        }
      });
    },
    loadItemData () {
      FormUtils.loadItemData(this, {
        endpointBase: '/orders/item/',
        id: this.isEdit,
        instanceFields: ['id', 'customer_id', 'description', 'shop_id', 'delivery_date', 'quantity', 'weight', 'products', 'containers_number', 'count', 'customer_name', 'customer_note', 'customer'],
        loadedKey: 'loaded',
        successAction: () => {
          this.products_init = [...this.data.products];
          if (this.hasBackup()) {
            Vue.set(this, 'show_backup_alert', true);
          }
        }
      });
    },
    addProduct () {
      this.products_to_send.push({
        id: 0,
        product_id: 0,
        quantity: 0,
        weight: 0,
        price: 0,
        weighing_required: 0,
        product_unit: 'KILOGRAM',
        average_weight: 0,
        description: null,
        unit: '',
        productValueSaved: false,
        isEditable: true
      });

      this.$nextTick(() => {
        let inputRef = this.$refs['product-select-' + (Number(this.products_to_send.length) - 1)];
        if (inputRef && inputRef[0]) {
          let inputEl = inputRef[0].$el.querySelectorAll('input')[0];
          if (inputEl) {
            inputEl.focus();
          }
          setTimeout(() => {
            if (inputEl) {
              inputEl.focus();
            }
          }, 500);
        }
      });
    },
    getProductsTodo () {
      this.products_to_send = [];
      this.sum = [];
      this.priceCalc = [];
      const items = this.data.products;
      this.data.count = 0;
      if (items.length > 15) {
        this.viewMode = 'grid';
      }
      for (let d = 0; d < items.length; d++) {
        this.products_to_send[d] = {
          id: items[d].id,
          product_id: items[d].product_id,
          quantity: Number(items[d].quantity),
          weight: items[d].weight !== null ? Number(items[d].weight) : null,
          price: items[d].product_unit === 'KILOGRAM' ? (Number((items[d].weight === null || items[d].weight === '0.00' || items[d].weight === 0.00) ? items[d].quantity : items[d].weight) * Number(items[d].product_price)) :
          (Number((items[d].weight === null || items[d].weight === '0.00' || items[d].weight === 0.00) ? (items[d].quantity * (items[d].average_weight !== '0.00' ? items[d].average_weight : 1)) : items[d].weight) * Number(items[d].product_price)),
          unit: items[d].product_unit,
          description: items[d].description,
          product_unit: !items[d].product_unit && items[d].default_unit ? items[d].default_unit : items[d].product_unit,
          average_weight: items[d].average_weight,
          weighing_required: items[d].weighing_required,
          is_packed: items[d].is_packed,
          name: items[d].product_name
        };
        let price = [];
        price[d] = Number(items[d].product_price);
        this.priceCalc.push(Number(items[d].product_price));
        this.sum[d] = price[d];
        this.updateSum();
        this.data.count += 1;
      }
    },
    changePricesInTab () {
      const items = this.data.products;
      this.products_to_send = [];
      this.sum = [];
      this.priceCalc = [];
      for (let d = 0; d < items.length; d++) {
        let productItem = [];
        productItem[d] = JSON.parse(JSON.stringify(this.shop_items_new.filter(product => product.id === items[d].product_id)[0]));
        this.products_to_send[d] = {
          id: items[d].id,
          product_id: items[d].product_id,
          quantity: Number(items[d].quantity),
          weight: Number(items[d].weight),
          price: Number(productItem[d].price) * Number(items[d].weight),
          unit: items[d].unit,
          description: items[d].description,
          product_unit: items[d].product_unit,
          average_weight: items[d].average_weight,
          weighing_required: items[d].weighing_required
        };
        this.priceCalc.push(Number(productItem[d].price));
        this.updateSum();
      }
      this.data.count += 1;
    },
    updateProduct (productID, index) {
      this.data.count = 0;
      let productItem = JSON.parse(JSON.stringify(this.shop_items_new.filter(product => product.id === productID)[0]));
      this.priceCalc[index] = Number(productItem.price);
      this.products_to_send[index].unit = productItem.unit || productItem.default_unit;
      this.products_to_send[index].weighing_required = productItem.weighing_required;
      this.products_to_send[index].average_weight = productItem.average_weight;
      this.products_to_send[index].default_unit = productItem.default_unit;
      this.products_to_send[index].product_price = productItem.price;

      if (this.products_to_send[index].weighing_required === 1) {
        this.products_to_send[index].product_unit = this.products_to_send[index].default_unit;
      } else {
        this.products_to_send[index].product_unit = 'PIECE';
      }
      if (this.products_to_send[index].weight !== 0 || this.products_to_send[index].quantity !== 0) {
        if (this.products_to_send[index].weight === 0) {
          this.updateQuantity(this.products_to_send[index].quantity, index, this.products_to_send[index].average_weight, 'KILOGRAM');
        } else {
          this.updateWeight(this.products_to_send[index].weight, index);
        }
      }
      this.focusNextEnabledProductInput(index);
    },
    changeValueWeight (index) {
      this.updateWeight(this.products_to_send[index].weight, index);
    },
    updateQuantity (value, index, average, unit) {
      this.data.count = 0;
      if (unit !== this.unit_box) {
        this.unit_box = unit;
        this.changeValueWeight(index);
      }
      if (this.products_to_send[index].weight === null || this.products_to_send[index].weight === '' || this.products_to_send[index].weight === 0 || this.products_to_send[index].weight === '0' || !this.products_to_send[index].weight) {
        let quantity = (unit === 'PIECE') ? (Number(value) * (average !== '0.00' ? average : 1)) : Number(value);
        this.products_to_send[index].price = Number(this.priceCalc[index]) * quantity;
        this.sum[index] = 0;
        if (this.products_to_send[index].price) {
          this.sum[index] = this.products_to_send[index].price;
        }
        this.updateSum();
        setTimeout(() => {
          this.data.count += 1;
        }, 200);
      }
    },
    updateWeight (value, index) {
      this.show_change_alert = true;
      this.data.count = 0;
      if (this.products_to_send[index].weight !== 0 && value) {
        let weight = value !== '0' ? Number(value) : Number(this.products_to_send[index].quantity);
        this.sum[index] = 0;
        this.products_to_send[index].price = Number(this.priceCalc[index]) * weight;
        if (this.products_to_send[index].price) {
          this.sum[index] = this.products_to_send[index].price;
        }
        setTimeout(() => {
          this.data.count += 1;
          this.updateSum();
        }, 200);
      } else {
        this.updateQuantity(this.products_to_send[index].quantity, index, this.products_to_send[index].average_weight, this.products_to_send[index].product_unit);
      }
      this.$forceUpdate();
    },
    updateSum () {
      this.data.count = 0;
      this.suma = 0;
      const allProducts = this.products_to_send;
      for (let c = 0; c < allProducts.length; c++) {
        this.suma += Number(allProducts[c].price);
        this.data.count += 1;
      }
    },
    removeProduct (index) {
      this.products_to_send.splice(index, 1);
      this.priceCalc.splice(index, 1);
      this.sum.splice(index, 1);
      this.updateSum();
    },
    setIsPacked (index) {
      this.products_to_send[index].is_packed = 1;
      this.updateSum();
    },
    validateForm () {
      FormUtils.validate(this.$refs['weighing-module-form'], this.submitForm);
    },
    submitForm () {
      let formDataToSend = {
        customer_id: this.data.customer_id,
        shop_id: this.data.shop_id,
        delivery_date: this.data.delivery_date,
        supplier_id: this.supplier,
        containers_number: this.data.containers_number,
        products: this.products_to_send
      };
      let endpointUrl = '/orders/update/' + this.isEdit;
      this.saveStateBackup();

      FormUtils.submit(this, {
        endpoint: endpointUrl,
        formData: formDataToSend,
        successTitle: 'Zapisano ważenie',
        successText: 'Wybrane ważenie zostało zapisane',
        errorTitle: 'Wystąpił błąd',
        errorText: 'Modyfikacja ważenie nie powiodła się. Spróbuj ponownie.',
        timer: 2000,
        successAction: () => {
          this.removeStateBackup(this.data.id);
          this.refreshList();
          this.closeModal();
        }
      });
    },
    hasBackup () {
      return !!localStorage.getItem('wedliny-crm-weight-module-' + this.data.id);
    },
    saveStateBackup () {
      let stateToSave = JSON.stringify({
        containers_number: this.data.containers_number,
        products: this.products_to_send
      });

      localStorage.setItem('wedliny-crm-weight-module-' + this.data.id, stateToSave);
      this.updateBackupsDB(this.data.id, +new Date());
      this.cleanUpBackups();
    },
    restoreBackup () {
      let backup = localStorage.getItem('wedliny-crm-weight-module-' + this.data.id);
      backup = JSON.parse(backup);
      this.data.containers_number = backup.containers_number;
      this.products_to_send = JSON.parse(JSON.stringify(backup.products));
      this.show_backup_alert = false;
      this.removeStateBackup(this.data.id);
    },
    removeStateBackup (orderID) {
      localStorage.removeItem('wedliny-crm-weight-module-' + parseInt(orderID, 10));

      let db = localStorage.getItem('wedliny-crm-weight-module-db');

      if (db) {
        db = JSON.parse(db);
        let dbKeys = Object.keys(db);

        for (let i = 0; i < dbKeys.length; i++) {
          if (db[dbKeys[i]] === orderID) {
            delete db[dbKeys[i]];
          }
        }

        localStorage.setItem('wedliny-crm-weight-module-db', JSON.stringify(db));
      }
    },
    updateBackupsDB (orderID, timestamp) {
      let db = localStorage.getItem('wedliny-crm-weight-module-db');

      if (db) {
        db = JSON.parse(db);
        let dbKeys = Object.keys(db);

        for (let i = 0; i < dbKeys.length; i++) {
          if (db[dbKeys[i]] === orderID) {
            delete db[dbKeys[i]];
          }
        }

        db[timestamp] = orderID;
        localStorage.setItem('wedliny-crm-weight-module-db', JSON.stringify(db));
      } else {
        localStorage.setItem('wedliny-crm-weight-module-db', JSON.stringify({ [timestamp]: orderID }));
      }
    },
    cleanUpBackups () {
      let db = localStorage.getItem('wedliny-crm-weight-module-db');
      const HISTORY_LENGTH = 50;

      if (!db) {
        return;
      }

      db = JSON.parse(db);
      let items = Object.keys(db);

      if (items.length > HISTORY_LENGTH) {
        console.warn('Too much history items detected');
        items.sort().reverse();

        for (let i = HISTORY_LENGTH; i < items.length; i++) {
          let orderID = db[items[i]];
          localStorage.removeItem('wedliny-crm-weight-module-' + parseInt(orderID, 10));
          delete db[items[i]];
        }

        localStorage.setItem('wedliny-crm-weight-module-db', JSON.stringify(db));
      }
    },
    focusNextEnabledProductInput (index) {
      this.$nextTick(() => {
        if (this.$refs['product-quantity-' + index]) {
          let quantityInput = this.$refs['product-quantity-' + index][0];

          if (!quantityInput.disabled) {
            quantityInput.focus();
            return;
          }
        }
        this.focusProductWeightInput(index);
      });
    },
    focusProductWeightInput (index) {
      if (this.$refs['product-weight-' + index]) {
        let weightInput = this.$refs['product-weight-' + index][0];
        if (weightInput && !weightInput.disabled) {
          weightInput.focus();
        }
      }
    },
    findClosesPrevProductWeightInputIndex (index) {
      let productWeightRefs = Object.keys(this.$refs).filter(item => this.$refs[item][0] && item.startsWith('product-weight-'));

      if (!productWeightRefs.length) {
        return null;
      }

      let smallerIndexes = productWeightRefs.map(item => item.split('-').pop()).filter(item => item < index);

      return Math.max(...smallerIndexes);
    },
    findClosesNextProductWeightInputIndex (index) {
      let productWeightRefs = Object.keys(this.$refs).filter(item => this.$refs[item][0] && item.startsWith('product-weight-'));
      if (!productWeightRefs.length) {
        return null;
      }

      let biggerIndexes = productWeightRefs.map(item => item.split('-').pop()).filter(item => item > index);

      return Math.min(...biggerIndexes);
    },
    focusDifferentProductWeight (e, index) {
      let newIndex = null;
      switch (e.keyCode) {
        case 38:
          e.preventDefault();
          newIndex = this.findClosesPrevProductWeightInputIndex(index);
          this.focusProductWeightInput(newIndex);
          break;
        case 40:
          e.preventDefault();
          newIndex = this.findClosesNextProductWeightInputIndex(index);
          this.focusProductWeightInput(newIndex);
          break;
        default:
          break;
      }
    },
    downloadLabel () {
      this.isDownloading = true;
      let date = CalendarUtils.formatDateForPHP(new Date());
      let filename = `etykieta-${this.data.customer_name}-${date}`;
      filename = filename.replaceAll(' ', '-');

      axios({
        url: `${api}orders/get-label/${this.data.id}`,
        method: 'POST',
        responseType: 'blob'
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', filename + '.pdf');
        document.body.appendChild(link);
        link.click();
        this.downloading = false;
      }).catch(error => {
        console.error(error);
        Vue.swal({
          title: 'Wystąpił błąd podczas pobierania',
          html: 'Spróbuj ponownie',
          type: 'warning',
          confirmButtonText: 'OK',
        });
        this.isDownloading = false;
      });
      setTimeout(() => {
        this.isDownloading = false;
      }, 2000);
    },
  }
};
</script>

<style lang="scss">
@import "@/assets/scss/variables/colors";

.crm-new-popup.weighing-module-form {
  .custom-grid-columns {
    display: grid;
    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
    grid-auto-flow: column;
  }

  .grid-headers {
    &.is-grid {
      .header-col {
        width: 50%;
      }
    }
    &.is-list {
      .header-col {
        width: 100%;
      }
    }
  }

  input, .selected{
    font-size: .9rem;
    font-weight: 500;
    line-height: 1.3;
    padding: 0.5rem;
  }
  .productsUnit {
    min-width: 80px;
  }

  .weighting-badge {
    height: 30px;
    width: 30px;
    padding-left: 0;
    padding-right: 0;

    .material-icons {
      top: 0;
    }
  }

  .grid-view-wrapper {
    &.is-list-mode {
      max-width: 800px;
      margin-left: auto;
      margin-right: auto;
    }

    .grid-item {
      border: 1px solid #e1e5eb;
      border-radius: 6px;
      font-size: 14px;
      transition: all 0.2s ease;
      height: 100%;

      &:hover {
        border-color: #007bff;
        box-shadow: 0 4px 6px rgba(0,0,0,0.1);
      }

      &.weighed {
        background-color: rgba(40, 167, 69, 0.1);
        border-color: rgba(40, 167, 69, 0.3);
      }

      .product-name {
        font-size: 0.875rem;
        line-height: 1.2;
      }

      .bg-success-light {
        background-color: #d4edda;
      }

      .bg-warning-light {
        background-color: #fff3cd;
      }

      .value-label {
        font-size: 9px;
        text-align: right;
        text-transform: uppercase;
      }

      .card-body > div {
        height: 100%;
      }

      .custom-input-new {
        height: 30px;
        line-height: 1;
        padding: 0 0.4rem;
      }

      .btn-icon {
        height: 30px;
        max-height: 30px;
        padding-bottom: 0.15rem;
        padding-top: 0.15rem;
      }

      small {
        font-size: 12px;
        font-weight: 500;
      }
    }
  }

  .spinner-load {
    text-align: center;
    .decision-spinner {
      color: #17c671;
      min-height: 2rem;
      min-width: 2rem;
    }
  }
  .weighing-module-address {
    color: #000;
    font-size: 1.2rem;
    font-weight: 100;
    opacity: 0.7;
    padding: 0;
    text-align: center;
    span {
      font-weight: 600;
    }
  }
  .weighing-module-subtitle {
    font-size: 1.8rem;
    font-weight: 500;
    margin-bottom: -7px;
    margin-top: 1rem;
    opacity: 0.8;
    padding: 0;
    text-align: center;
  }
  .modal-dialog {
    max-width: 1400px;
    width: 95vw;
    .modal-content {
      .modal-header {
        padding: 0.75rem 1rem;
        position: sticky;
        top: 1.875rem;

        .close {
          display: none !important;
        }


        .modal-title .weighing-module-title {
          font-size: 1.5rem;
        }
      }
    }
  }

  .order-weighing-table tbody:has(tr:nth-child(17)) {
    tr:first-of-type {
      background-color: rgba(#00b8d8, 0.2);
    }
  }
}
.order-button-description {
  border-radius: 20px;
  margin-top: 0.5rem;
}
.order-description textarea {
  min-height: 37px;
}

.weighing-modal-body {
  padding-left: 16px;
  padding-right: 16px;
  padding-top: 14px;
  z-index: 2;
}

.border-orange{
  border-color: orange!important;
}
textarea {
  border: 1px solid var(--form-border-color);
  border-radius: 5px;
  margin-bottom: -4px;
  margin-top: 1px;
  min-height: 4rem;
  outline: none;
  outline: none;
  width: 100%;
  &:focus {
    background-color: var(--content-background);
    border-color: #007BFF;
    box-shadow: 0 0.313rem 0.719rem rgba(0, 123, 255, 0.1), 0 0.156rem 0.125rem rgba(0, 0, 0, 0.06);
    color: var(--text-color);
  }
}

@media only screen and (min-width: 1241px) {
  .crm-new-popup.weighing-module-form .modal-dialog {
    box-shadow: none;

    .modal-content {
      background: none;
      border-radius: 0 0.5rem 0.5rem  0.5rem;
      box-shadow: none;
      display: flex;
      flex-direction: row;

      .modal-header,
      .modal-body {
        background-color: var(--content-background);
      }

      .modal-header {
        border: none!important;
        border-radius: 0.5rem 0 0 0.5rem;
        flex-shrink: 0;
        margin-bottom: auto;
        padding: 1rem;
        width: 300px;

        .weighing-module-title {
          font-size: 1.2rem!important;
          line-height: 1;

          &-bottom {
            .col {
              max-width: unset;
              min-width: 100%;
            }

            .form-group {
              margin-top: 10px!important;
              margin-bottom: 10px;
            }
          }
        }

        .custom-control {
          line-height: 1.2;
        }
      }

      .modal-body {
        border-radius: 0 0.5rem 0.5rem 0.5rem;
      }
    }
  }
}

@media only screen and (max-width: 1024px) {
  .crm-new-popup.weighing-module-form .modal-dialog {
    width: 98vw;
  }
  .table.order-weighing-table tbody tr:first-of-type {
    background-color: rgba(#00b8d8, 0.2);
  }
}

@media only screen and (max-width: 880px) {
  .custom-grid-columns {
    grid-template-columns: 1fr !important;
    grid-template-rows: auto !important;
    grid-auto-flow: row !important;
  }

  .view-mode-switcher {
    display: none!important;
  }

  .grid-headers.is-grid {
    .header-col {
      width: 100%;
    }
    .d-none.d-md-block {
      display: none !important;
    }
  }
}
</style>
